import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Login from "../Auth/login";
import * as BsIcons from "react-icons/bs";
import TabPanel from "../Auth/TabPanel";
import * as BiIcons from "react-icons/bi";
import { HiChevronDown } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { getUserNotification, getUserProfile } from "../Redux/Slices/ProfileSlice";
import { menuData, userRole } from "../JsonData/json";
import CommonModal from "./CommonModal";
import { BsWhatsapp } from "react-icons/bs";
import { MdDashboard } from "react-icons/md";
import { FaUser, FaLock, FaSignOutAlt } from "react-icons/fa";
import { Avatar } from "@mui/material";


const menuItems = [
  {
    to: "/UserDashboard",
    className: "dropdown-item profile-drop-item",
    icon: <MdDashboard className="me-2" />,
    label: "Dashboard"
  },
  {
    to: "/MyProfile",
    className: "dropdown-item profile-drop-item",
    icon: <FaUser className="me-2" />,
    label: "My Profile"
  },
  {
    to: "/MyProfile",
    className: "dropdown-item profile-drop-item",
    icon: <FaLock className="me-2" />,
    label: "Change Password"
  },
  {
    to: null,
    className: "dropdown-item profile-drop-item",
    icon: <FaSignOutAlt className="me-2" />,
    label: "Logout",
    // onClick: () => logout()
  }
];

function Navbar() {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const UserProfile = localStorage.getItem("ProfileImg");
  const userRole = localStorage.getItem('userRole')
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const Title = "Update KYC"
  const Description = "To Post Property You Need To Update the KYC"

  const User = useSelector((state) => state.userProfile.profile);
  console.log("selector", User);

  const [SubscriptionModal, setSubscriptionModal] = useState(false)
  const [prevNotificationCount, setPrevNotificationCount] = useState(0);
  const UserNotification = useSelector((state) => state.userProfile.Notification);


  useEffect(() => {
    const userData = {
      headers: {
        authorization: token,
      },
    };

    dispatch(getUserProfile({ id: userId, data: userData }));
  }, [userId, token]);


  useEffect(() => {
    setPrevNotificationCount(UserNotification.length);

    const userData = {
      headers: {
        authorization: token,
      },
    };

    dispatch(getUserNotification({ id: userId, data: userData }));

    // Update prevNotificationCount after fetching new notifications
    setPrevNotificationCount(UserNotification.length);
  }, [userId, token, dispatch]);

  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  const redirect = () => {
    navigate("/MyProfile")
    setSubscriptionModal(false)
  }

  const postProperty = () => {

    User?.Userdata.aadharverification  == false && User?.Userdata?.panverification == false ?
      setSubscriptionModal(true)
      :
      navigate("/AddProperty")
  }
  


  return (
    <header class="main-header  navbar-light header-sticky header-sticky-smart header-mobile-lg mb-7">
      <div class="sticky-area">
        {SubscriptionModal && <CommonModal Title={Title} Description={Description} setModal={setSubscriptionModal} ButtonName={"Update KYC"} Submit={redirect} />}
        <div class="container">
          <nav class="navbar navbar-expand-lg   fixed-top pt-0 pt-lg-2 ">
            <Link to="/" class="navbar-brand ">
              <img
                src="../images/logo-property-nexus-removebg-preview.png"
                alt="Property Nexus"
                height={170}
                width={200}
              />
            </Link>
            <div className="d-flex d-lg-none">
              <button class="navbar-toggler bg-white " type="button" data-bs-toggle="collapse" data-bs-target="#primaryMenu01" aria-controls="primaryMenu01" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>
              {token != null ? null : (
                <li class="nav-item ">
                  <Link
                    to="/Login"
                    class="nav-link text-white px-2"
                    data-toggle="modal"
                    href="#login-register-modal"
                  >
                    Sign In
                  </Link>
                </li>
              )}
              {token != null ? (
                <div class="dropdown profile-drop">
                  <div className="dropdown-toggle">
                    <img
                      class="profile-img border rounded-circle ms-3 "
                      src={User?.ProfileImage ? User?.ProfileImage : "https://www.pngitem.com/pimgs/m/661-6619328_default-avatar-png-blank-person-transparent-png.png"}
                      alt=""
                    />
                  </div>
                  <div class="dropdown-menu profile-drop-menu">
                    <div class="d-flex">
                      <div class="pro-img">
                        <img
                          class="prof-img border rounded-circle ms-3"
                          src={User?.ProfileImage ? User?.ProfileImage : "https://www.pngitem.com/pimgs/m/661-6619328_default-avatar-png-blank-person-transparent-png.png"}
                          alt=""
                        />
                      </div>
                      <div class="pro-details">
                        <p>
                          {User?.Userdata?.firstname}{" "}
                          {User?.Userdata?.lastname}
                        </p>
                        <p>Free Member</p>
                      </div>
                    </div>
                    <div class="dropdown-divider"></div>

                    {menuItems.map((item, index) => (
                      item.to ? (
                        <Link
                          key={index}
                          to={item.to}
                          className={item.className}
                        >
                          {item.icon} {item.label}
                        </Link>
                      ) : (
                        <a
                          key={index}
                          className={item.className}
                          onClick={()=>logout()}
                          style={{cursor:"pointer"}}
                        >
                          {item.icon} {item.label}
                        </a>
                      )
                    ))}

                  </div>
                </div>
              ) : null}
            </div>
            <div
              className="collapse navbar-collapse mobile-togle-click mt-3 mt-lg-0 mx-auto flex-grow-0"
              id="primaryMenu01"
            >
              <ul className="navbar-nav hover-menu main-menu px-0 mx-lg-n4">
                {menuData.map((menuItem, index) => (
                  <li className="nav-item dropdown" key={index}>

                    <>
                      <a
                        className="nav-link dropdown-toggle p-0"
                        href="#"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {menuItem.label}
                        <span className="caret"></span>
                      </a>
                      <ul className="dropdown-menu" style={{ width: menuItem.width }}>
                        <div className="row">
                          {menuItem.columns.map((column, colIndex) => (
                            <div className="col-lg-4" key={colIndex}>
                              <p className="text-primary pl-3">{column.title}</p>
                              <hr className="dropdown-divider" style={{ color: "black" }} />
                              {column.items.map((item, itemIndex) => (
                                <li key={itemIndex}>
                                  <Link
                                    to="/PropertyListHome"
                                    state={{
                                      type: item.category,
                                      subCategory: colIndex === 0 ? item.subCategory : null,
                                      budget: colIndex === 1 ? item.budget : null,
                                      loc: colIndex === 2 ? item.location : null,
                                    }}
                                    className="dropdown-item"
                                  >
                                    {item.label}
                                  </Link>
                                </li>
                              ))}
                            </div>
                          ))}
                        </div>
                      </ul>
                    </>
                  </li>
                ))}

                <li class="nav-item dropdown">
                  <a
                    class="nav-link dropdown-toggle nav-buy"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Sell
                    <span class="caret"></span>
                  </a>
                  <ul class="dropdown-menu " style={{ width: '300px' }}>
                    <div class="row">
                      <div class="col-lg-6">
                        <p className="text-primary pl-3">Selling Tools</p>
                        <hr
                          className="dropdown-divider"
                          style={{ color: "black" }}
                        />
                        <li>
                          <Link
                            to="/home/propertyevaluation-guidance"
                            class="dropdown-item"

                          >
                            {" "}
                            Property Valuation
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/PropertyListHome"
                            state={{
                              param1: " Find an Agent",
                              param2: "Buy",
                            }}
                            class="dropdown-item"
                            href="#"
                          >
                            Find an Agent
                          </Link>
                        </li>

                      </div>

                    </div>
                  </ul>
                </li>
                <li class="nav-item dropdown">
                  <a
                    class="nav-link dropdown-toggle nav-buy"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Property Services
                  </a>
                  <ul class="dropdown-menu " style={{ width: '300px' }}>
                    <div class="row">

                      <div class="col-lg-7 ">
                        <p className="text-primary pl-3">Buy / Sell Services</p>
                        <hr
                          className="dropdown-divider"
                          style={{ color: "black" }}
                        />
                        <li>
                          <Link
                            to="/home/homedesign-guidance"
                            class="dropdown-item"
                          >
                            {" "}
                            Home Interiors
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/home/propertyevaluation-guidance"
                            class="dropdown-item"
                            href="#"
                          >
                            Property Valuation
                          </Link>
                        </li>
                        <li>
                          <Link
                            class="dropdown-item"
                            href="#"
                          >
                            Legal Title Check
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/PropertyListHome"
                            state={{ param1: "Property Lawyers", param2: "Buy" }}
                            class="dropdown-item"
                            href="#"
                          >
                            Property Lawyers
                          </Link>
                        </li>
                      </div>
                    </div>
                  </ul>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link nav-buy"
                    href="https://wa.me/7506348004?text=Hello%20I%20have%20a%20question"
                    // href="https://web.whatsapp.com/7506348004?text=Hello%20I%20have%20a%20question"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Contact Us   <BsWhatsapp color="green" />
                  </a>
                </li>
              </ul>
            </div>
            <div class="d-none d-lg-block">
              <ul class="navbar-nav flex-row justify-content-lg-end d-flex flex-wrap text-body mt-0 py-2">
             
                
                <li class="nav-item ml-auto w-100 w-sm-auto">
                    <button
                      onClick={() =>navigate("/home/propertyAnalysis")}
                      class="btn btn-primary btn-sm p-2 me-2"
                    >
                      Analysis
                    </button>
                  </li>
                {token != null ? null : (
                  <li class="nav-item">
                    <Link
                      to="/Login"
                      class="nav-link  px-2"
                      data-toggle="modal"
                      href="#login-register-modal"
                    >
                      Sign In
                    </Link>
                  </li>
                )}
                {userRole === "user" ?

                  <li class="nav-item ml-auto w-100 w-sm-auto">
                    <button
                      onClick={() => postProperty()}
                      class="btn btn-primary btn-sm p-2 "
                    >
                      Post Property
                    </button>
                  </li>
                  :
                  null
                }
                {token != null ? (
                  <div class="dropdown profile-drop">
                    <div className="dropdown-toggle">
                      <img
                        class="profile-img border rounded-circle ms-2"
                        src={User?.ProfileImage}
                        alt=""
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null; // prevents looping
                          currentTarget.src = "https://www.pngitem.com/pimgs/m/661-6619328_default-avatar-png-blank-person-transparent-png.png";
                      }}
                        
                      />
                    </div>
                    <div class="dropdown-menu profile-drop-menu">
                      <div class="d-flex">
                        <div class="pro-img">
                          <img
                            class="prof-img border rounded-circle ms-3 h-10"
                            src={User?.ProfileImage}
                            alt=""
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src = "https://www.pngitem.com/pimgs/m/661-6619328_default-avatar-png-blank-person-transparent-png.png";
                          }}
                          />
                        </div>
                        <div class="pro-details">
                          <p>
                            {User?.Userdata?.firstname}{" "}
                            {User?.Userdata?.lastname}
                          </p>
                          <p>{User?.Userdata?.userrole == "user" ? "Buyer/Seller" : User?.Userdata?.userrole}</p>
                        </div>
                      </div>
                      <div class="dropdown-divider"></div>

                      {menuItems.map((item, index) => (
                        item.to ? (
                          <Link
                            key={index}
                            to={item.to}
                            className={item.className}
                          >
                            {item.icon} {item.label}
                          </Link>
                        ) : (
                          <a
                            key={index}
                            className={item.className}
                            onClick={()=>logout()}
                            style={{cursor:"pointer"}}
                          >
                            {item.icon} {item.label}
                          </a>
                        )
                      ))}

                    </div>
                  </div>
                ) : null}
                {token != null &&

                <div class="dropdown no-caret  px-sm-2 d-flex align-items-center justify-content-end notice">
                  <Link
                    to="/Notification"
                    state={{ notificationData: UserNotification }}
                  
                  >
                    <BsIcons.BsBell color="white" size={20} />

                    {UserNotification.length > prevNotificationCount && (
                      <span className="badge badge-success badge-circle badge-absolute font-weight-bold fs-7">
                        {UserNotification.length - prevNotificationCount}
                      </span>
                    )}
                  </Link>
                </div>

                }
                
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
